import React, {
    useState,
    useEffect
} from "react";
import {
    Button,
    Modal
} from "react-bootstrap";
import * as Icon from "react-bootstrap-icons";
import stringSimilarity from 'string-similarity';

export const ReturnModal = (props) => {
    const [returnId, setReturnId] = useState()
    const [partnerNames, setPartnerNames] = useState()
    const [statuses, setStatuses] = useState()
    const [rows, setRows] = useState()
    useEffect(() => {
        setRows(props.selectedrows)
    }, [props.selectedrows])

    useEffect(() => {
        if (rows !== undefined) {
            const pns = new Set()
            const sts = new Set()
            for (let row of rows) {
                // console.log("ROW: ", row)
                pns.add(row.ActiveKone.PartnerName)
                sts.add(row.ActiveKone.Status)
            }
            // const pn = new Set(['Aditya', 'Adityacp', 'Adityacpatil', 'Mustafa', 'Mustafaq', 'Mustafaqazi'])
            setPartnerNames(pns)
            setStatuses(sts)
        }
    }, [rows])


    const [subsets, setSubsets] = useState([]);
    const groupSimilarStrings = (strings) => {
        const threshold = 0.6
        const groupedSubsets = [];
        const visited = new Set();

        for (let i = 0; i < strings.length; i++) {
            if (!visited.has(strings[i])) {
                const subset = [strings[i]];
                visited.add(strings[i]);

                for (let j = i + 1; j < strings.length; j++) {
                    if (!visited.has(strings[j])) {
                        const similarity = stringSimilarity.compareTwoStrings(strings[i], strings[j]);
                        if (similarity >= threshold) {
                            subset.push(strings[j]);
                            visited.add(strings[j]);
                        }
                    }
                }

                groupedSubsets.push(subset);
            }
        }

        setSubsets(groupedSubsets);
    };

    useEffect(() => {
        if (partnerNames !== undefined) {
            groupSimilarStrings(Array.from(partnerNames))
        }
    }, [partnerNames])

    const [distinctPartners, setDistinctPartners] = useState()
    useEffect(() => {
        // console.log("SETS OF SIMILAR STRINGS: ", subsets)
        const dp = subsets.map(set => set[0])
        setDistinctPartners(dp)
    }, [subsets])

    const [areAllVerified, setAreAllVerified] = useState(false)
    useEffect(() => {
        if (statuses !== undefined) {
            const verified = Array.from(statuses).length > 1 ? false : Array.from(statuses).length == 1 && Array.from(statuses)[0] === "Verified" ? true : false
            setAreAllVerified(verified)
            // console.log("VERIFIED: ", verified)
        }
    }, [statuses])

    return (
        <Modal
            {...props}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            // backdropClassName="custom-backdrop"
            backdrop="static"
            centered
            scrollable="false"
            style={{
                maxHeight: 500,
                overflow: "auto",
                top: "20%"
            }}
        >
            <Modal.Header closeButton>
                {
                    !areAllVerified ? <h5><Icon.ExclamationDiamondFill fill="red" /> &nbsp;Not all selected files are verified!</h5> : <></>
                }
                {
                    areAllVerified && subsets.length > 1 ? <h5><Icon.ExclamationDiamondFill fill="orange" /> &nbsp;Files for different partners have been selected</h5> : <></>
                }
            </Modal.Header>
            <Modal.Body className="flex-row-center-start">

                {
                    !areAllVerified ? "Only verified files can be imported to tax. Please check the selected files." : <></>
                }
                {
                    areAllVerified && subsets.length > 1 ?
                        <>
                            <>It is recommended that you select the files for the same partner for importing to tax.
                                <br /><br />
                                The files you have selected are for different partners including </>
                            <ul style={{ paddingLeft: "1rem" }}>
                                {
                                    distinctPartners.map((partner, index) => (
                                        <li key={index}><b>• {partner}</b></li>
                                    ))
                                }
                            </ul>
                            {/* <b>{distinctPartners.join(', ')}</b> */}
                            <>Please check the selected files or ignore this warning and continue.</>
                        </>
                        :
                        <></>
                }


            </Modal.Body>
        <Modal.Footer className="flex-row-center-start">
                {areAllVerified && subsets.length >= 1 ?
                    <>
                        <h6>Please provide your Return ID for Tax</h6>
                        {/* <label style={{ margin: "0px 5px" }}>Return ID: </label> */}
                        <input type="text"
                            className="form-control move-left custom-input"
                            id="exampleInputEmail1"
                            aria-describedby="emailHelp"
                            placeholder={'Enter return ID'}
                            value={returnId}
                            onChange={(event) => setReturnId(event.target.value, undefined)}
                            autoComplete="nope"
                            required
                            style={{ marginRight: 20 }}
                        />
                        <Button className="custom-button" style={{
                            width: "fit-content",
                            display: "inline-block",
                            padding: "5px 10px",
                        }} onClick={() => props.submit(returnId)}
                            disabled={returnId !== undefined ? false : true}>
                            Submit
                        </Button>
                    </> :
                    <></>
                }
            </Modal.Footer>
        </Modal>
    )
}